import { GearIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Setting = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <GearIcon width={Sizes[size]} {...rest} />;
};

Setting.displayName = 'Setting';
